import Model from "./base/model";

class SimulationTableTda extends Model{
  resourceName() {
    return "simulation_table_tda";
  }

  fields() {
    return {
      simulation_table_id: "",
      city_id: "",
      value: "",
      city: "",
      simulation_table: { jsonApi: "hasOne", type: "simulation_tables"},

    };
  }

}

export default new SimulationTableTda();
